<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Purchase Invoice #{{data.code}}</h4>
                    <p class="text-subtitle-1">Displaying Purchase Invoice</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn color="primary" block @click="handlePrint">
                        <v-icon left>mdi-printer</v-icon>
                        print
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(perm.invoice.update)">
                    <v-btn block depressed @click="handleEdit">
                        <v-icon left>mdi-pencil</v-icon>
                        edit
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(perm.invoice.delete)">
                    <v-btn block depressed @click="handleDelete" :loading="deleteLoading" color="error--text">
                        <v-icon left>mdi-delete</v-icon>
                        delete
                    </v-btn>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="3">
                    <v-menu
                        offset-y
                        min-width="250"
                    >
                        <template v-slot:activator="{ attrs, on }" v-if="menu.length > 0">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                depressed
                                block
                            >
                                <v-icon left> mdi-dots-vertical</v-icon>
                                actions
                            </v-btn>
                        </template>
                        <v-list
                            
                            dense
                            flat
                            outlined
                        >
                            <v-list-item link v-for="(d, i) in list" :key="i" @click="d.callback">
                                <v-list-item-icon>
                                    <v-icon>{{d.icon}}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{d.text}}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <PurchaseInvoice :value="data"/>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PAlert from './../../components/common/PAlert'
import PurchaseInvoice from "./../../components/purchase/PurchaseInvoice.vue"
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "PurchaseInvoiceDisplayView",
    components: {
        PurchaseInvoice,
        PAlert
    },
    data() {
        return {
            id: null,
            loading: false, 
            deleteLoading: false,
            data: {}, 
            alert:{
                value: false,
                content: 'Are you sure',
                callback: null
            },
            perm: permissions
       }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        }),
        list(){
            return [
                {
                    text: "Post to Ledger",
                    icon: "mdi-post",
                    callback: this.handlePost,
                    permission: this.hasPermission(this.perm.invoice.post)
                }
            ]
        },
        menu() {
            return this.list.filter(item => item.permission === true)
        }
    },
    methods:{
        ...mapActions({
            findByID: "purchase/invoice/findByID",
            post: "purchase/invoice/post",
            print: "purchase/invoice/print",
            snackbar: "ui/snackbar/show",
            remove: "purchase/invoice/remove",
        }),
        getAsync() {
            this.loading = true;
            this.findByID(this.id).then(response => {
                this.data = response.data;
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
            }).finally(() => {
                this.loading = false;
            })
        },
        handleList() {
            this.$router.push({name: "PurchaseInvoiceList"})
        },
        handleCreate() {
            this.$router.push({ name:"PurchaseInvoiceCreate"})
        },
        handleEdit() {
            this.$router.push({ name: "PurchaseInvoiceEdit", params: { id: this.id } })
        },
        handlePost() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to post this invoice?", callback: this.postAsnyc}
        },
        postAsnyc() {
            this.loading = true;
            this.post(this.data).then(response => {
                this.data = response.data;
                this.snackbar({color: "success", text: "invoice posted successfully"});
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
            }).finally(() => {
                this.loading = false;
            })
        },
        handlePrint() {
            this.print(this.data)
                .then(response => {
                    var printWindow = window.open('','','width=800,height=600');
                    printWindow.document.write(response.data);
                    printWindow.document.close();
                    printWindow.focus();
                    printWindow.print();
                    printWindow.close();
                })
                .catch(error => {
                    let message = error.response ? error.response.data.message : error;
                    this.snackbar = { value: true, color: "error", text: message }
                });
        },
        handleDelete() {
            this.alert = {...this.alert, content: "Are yous sure you want to delete?", value: true, callback: this.removeAsync}
        },
        removeAsync() {
            this.deleteLoading = true;
            this.remove(this.data).then(() => {
                this.$router.push({name: "PurchaseInvoiceList", params: { id: this.id }})
            }).finally(() => {
                this.deleteLoading = false;
            })
        },
    },
    created() {
        this.id = this.$route.params.id;
        this.getAsync()
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.getAsync()
        next();
    }
}
</script>

<style>

</style>